import { useCallback } from "react";
import { ResetProposalState } from "..";
import { clearPromotions } from "../../promotions";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { ResetProposalState as ResetOldProposal } from "../../proposal_old";

const useClearProposal = () => {
  const dispatch = useAppDispatch();

  const clearProposalState = useCallback(() => {
    dispatch(ResetOldProposal());
    dispatch(ResetProposalState());
    dispatch(clearPromotions());

    localStorage.removeItem("selectedPosId");
    localStorage.setItem("reachableCreationStep", "0");
  }, [dispatch]);

  return clearProposalState;
};

export default useClearProposal;
